import { querySearch } from '@tencent/nb-h5-tools';

const Base = {
  beforeCreate() {
    setThirdeyeId();
  },
};

function setThirdeyeId() {
  // 尝试设置埋点实时监测平台的监测 id
  const rimId = querySearch('rimId');
  if (rimId) {
    document.cookie = `rim_id=${rimId};path=/;domain=.qq.com;SameSite=none;Secure`;
  }
}

export default Base;
